"use client";

import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";

import { useComponentLifecycle } from "@stadium/hooks/lib/use-component-lifecycle";

import OrganiserOrderConfirmation from "@components/modals/order-confirmation";

import { useStoreContext } from "@components/store/provider";
import { useEventLocationContext } from "@stadium/services/analytics/context/event-location";
import useActionEvents from "@stadium/services/analytics/hooks/use-action-events";

const StoreHomePageWrapper = ({ withMenu = true, children }) => {
  const [showOrderConfirmation, setShowOrderConfirmation] = useState(false);

  const toggleOrderConfirmation = () => setShowOrderConfirmation(!showOrderConfirmation);

  const searchParams = useSearchParams();
  const orderNumber = searchParams.get("orderNumber");

  const { setPageState, resetPageState, storeNumber } = useStoreContext();

  useComponentLifecycle({ onUnmount: resetPageState });

  const { services, location, baseEventLocationProperties } = useEventLocationContext();
  const { trackPage } = useActionEvents(services);

  useEffect(() => {
    if (!location) return;
    trackPage({ shop_number: storeNumber, page: location, ...baseEventLocationProperties });
  }, [trackPage, storeNumber, location, baseEventLocationProperties]);

  useEffect(() => {
    if (orderNumber) {
      setShowOrderConfirmation(true);
    }
  }, [orderNumber]);

  useEffect(() => {
    setPageState((pageState) => ({ ...pageState, withMenu, showSendItemIcon: true }));
  }, [resetPageState, setPageState]);

  return (
    <>
      {children}
      {showOrderConfirmation && (
        <OrganiserOrderConfirmation
          orderNumber={orderNumber}
          closeModal={toggleOrderConfirmation}
        />
      )}
    </>
  );
};

export default StoreHomePageWrapper;
